import { createReducer, on } from '@ngrx/store';
import { ScatterPlotChartType } from 'ChartApp/ts/enums/scatter-plot-common.enum';
import { setChartType } from './chart-type.action';
import { setScatterPlot } from 'ChartApp/ts/apps/scatter-plot/state/scatter-plot.actions';
export const chartType = createReducer(ScatterPlotChartType.interactive, on(setChartType, (state, action) => {
    return action.chartType;
}), on(setScatterPlot, (state, action) => {
    return action.scatterPlot.chartType;
}));
